module.exports = __webpack_public_path__ + "files/4815c2ca4f00a5812a8f7545bf7c83e8.png";